import { Box, List, ListItem, ListItemText, SxProps, Theme, Typography } from '@mui/material';

const rootStyles: SxProps<Theme> = {
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
};
export function OutOfScopeCustomerVendor() {
  const reasons = [
    'Fees and Services',
    'Manufacturer Rep Vendor',
    'On Contract',
    'Out of Territory',
    'SPA',
    'Set price product',
  ];
  return (
    <Box sx={rootStyles}>
      <Typography variant='body2'>
        Please reach out to inside sales rep. This product and customer combination should not be re-priced in the quote
        tool due to one of the following:
      </Typography>
      <List dense component='ol'>
        {reasons.map(reason => (
          <ListItem key={reason}>
            <ListItemText primary={reason} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
